export default (route) => {
	if (route?.params?.chain) {
		return 'chainListingCart'
	}
	return 'businessCart'
}
